module.exports = __webpack_public_path__ + "img/Logistikeinheit.68b17d36.svg";